import { InjectionToken, TemplateRef, ViewContainerRef } from '@angular/core';

import { Observable } from 'rxjs';

import { MessageType } from './message-type';

export interface ToastParams {
  type: MessageType;
  title: string;
  message: MessageCopy;
  options?: ToastOptions;
}

export interface Toast extends ToastParams {
  id: number;
}

export interface ToastOptions {
  tapToDismiss: boolean;
  autoClose: boolean;
  timeout?: number;
  showCloseButton?: boolean;
  dataQaId?: string;
  uniqueKey?: string;
  displayPermanently?: boolean;
}

export type MessageCopy = string | TemplateRef<HTMLElement> | CartMessageDataDto;
type DisplayMessageFn = (message: MessageCopy, title?: string, options?: ToastOptions) => number;

export interface ToastMessagesFactory {
  globalToastContainerRef: ViewContainerRef;
  globalToastContainerElement: HTMLElement;
  getToasts$: () => Observable<Toast[]>;
  info: DisplayMessageFn;
  success: DisplayMessageFn;
  warn: DisplayMessageFn;
  danger: DisplayMessageFn;
  email: DisplayMessageFn;
  clear: () => void;
  registerToastContainer: (id: number) => void;
  unregisterToastContainer: (id: number) => void;
  createToast: () => number;
}

export const TOAST_MESSAGES_SERVICE = new InjectionToken<ToastMessagesFactory>('shared.ui-core.toastMessagesService');

export interface CartMessageData {
  image?: string;
  productTitle?: string;
  quantity?: number;
  roundUp?: boolean;
  showCartButton?: boolean;
  error?: {
    headline: string;
    text: string;
  };
}

export class CartMessageDataDto implements CartMessageData {
  image?: string;
  productTitle?: string;
  quantity?: number;
  roundUp?: boolean = false;
  showCartButton? = true;

  private constructor(args: CartMessageDataDto) {
    Object.assign(this, args);
  }

  static create(this: typeof CartMessageDataDto, args: CartMessageData): CartMessageDataDto {
    return new this(args);
  }
}
